import { render, staticRenderFns } from "./InputItem.vue?vue&type=template&id=0a777762&scoped=true"
import script from "./InputItem.vue?vue&type=script&lang=js"
export * from "./InputItem.vue?vue&type=script&lang=js"
import style0 from "./InputItem.vue?vue&type=style&index=0&id=0a777762&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a777762",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/acquirer/pingpong-acquirer-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a777762')) {
      api.createRecord('0a777762', component.options)
    } else {
      api.reload('0a777762', component.options)
    }
    module.hot.accept("./InputItem.vue?vue&type=template&id=0a777762&scoped=true", function () {
      api.rerender('0a777762', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form/InputItem.vue"
export default component.exports